import LegalLayout from './LegalLayout';

export default function AboutPage() {
  return (
    <LegalLayout title="关于我们">
      <p>StatFlow 是面向站长的网站流量统计平台，定位接近爱站统计：添加站点、安装一行代码，即可查看浏览量、独立 IP、独立访客、来源、搜索词和蜘蛛抓取。</p>
      <p>适合个人博客、企业官网、推广落地页和多站点运营。数据默认保存在本机与开发环境采集服务中，方便先跑通再接云端数据库。</p>
    </LegalLayout>
  );
}
